import logo from "./logo.svg";
import "./App.css";
import Header from "./components/Header";
import { useEffect, useState, useContext } from "react";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import MakePayment from "./components/MakePayment";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NotFound from "./components/NotFound";
import PrivateRoute from "./components/PrivateRoute";
import { CarrierContext } from "./contexts/CarrierContext";
import Login from "./components/Login";
import { JSEncryptProvider } from "./contexts/JSEncryptContext";
import { PaymentNachaProvider } from "./contexts/PaymentNachaContext";
import Confirmation from "./components/Confirmation/Confirmation";
import ContactUs from "./components/Contactus";
import Glossary from "./components/Glossary";
import LanguageProficiency from "./components/LanguageProficiency";
import Faq from "./components/Faq";
import { v4 as uuidv4 } from "uuid";
import { LogProvider } from "./contexts/LogContext";
import useSessionTimeout from "./components/userSessionTimeout";

function App() {
  // const { isLoggedIn = false } = useAuth() || {};
  //const { user, login } = useAuth();

  const [isLoggedIn, setLoggedIn] = useState("false");
  const carrierContxt = useContext(CarrierContext);

  const urlCarrier = carrierContxt.hasOwnProperty("carrier")
    ? carrierContxt.carrier
    : "";

  //To redirect all unwantes carrier urls to not found page
  const path = window.location.pathname;
  const isValidCarrier = carrierContxt.hasOwnProperty("isValidCarrier")
    ? carrierContxt.isValidCarrier
    : "";
  if (isValidCarrier === false && !path.includes("notfound") && path !== "/") {
    const notFound = "/" + urlCarrier + "notfound";
    window.location.replace(notFound);
  }

  const carr_code = "REACT_APP_" + urlCarrier.toUpperCase();
  function changeFavicon(iconURL) {
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "icon";
    link.href = iconURL;
    document.getElementsByTagName("head")[0].appendChild(link);
  }
  useEffect(() => {
    //Set logged in or not

    const user = sessionStorage.getItem("userData_" + process.env[carr_code]);
    if (user) {
      setLoggedIn("true");
    } else {
      setLoggedIn("false");
    }
    //Set favicon
    const faviconPath = "/images/favicon/" + urlCarrier + "_fav.svg";
    changeFavicon(`${faviconPath}`);
  }, [urlCarrier, carr_code]);

  //For identifying the user session in log API
  useEffect(() => {
    // Check if session ID exists in sessionStorage
    let storedSessionId = sessionStorage.getItem("sessionId");

    if (!storedSessionId) {
      // If no session ID, generate and store it
      storedSessionId = uuidv4();
      sessionStorage.setItem("sessionId", storedSessionId);
    }
  }, []);

  //User session timeout after 15 minutes of inactivity
  const handleSessionTimeout = () => {
    // Clear authentication-related data
    if (
      carr_code &&
      process.env[carr_code] &&
      sessionStorage.getItem("userData_" + process.env[carr_code])
    ) {
      sessionStorage.removeItem("userData_" + process.env[carr_code]);
    }

    if (sessionStorage.getItem("langSel")) {
      sessionStorage.removeItem("langSel");
    }
    if (sessionStorage.getItem("nacha_" + urlCarrier)) {
      sessionStorage.removeItem("nacha_" + urlCarrier);
    }
    if (sessionStorage.getItem("sessionId")) {
      sessionStorage.removeItem("sessionId");
    }
    if (urlCarrier) {
      window.location.replace("/" + urlCarrier);
    } else {
      const urlCarrier = carrierContxt.hasOwnProperty("carrier") // Set URL in carrier
        ? carrierContxt.carrier
        : "";
      window.location.replace("/" + urlCarrier);
    }
  };

  useSessionTimeout(handleSessionTimeout);

  return (
    <LogProvider>
      <AuthProvider>
        <Router>
          <LanguageProvider>
            <JSEncryptProvider>
              <PaymentNachaProvider>
                <Header></Header>
                <Routes>
                  {/* <Route
              path={`/${urlCarrier}/login`}
              element={isLoggedIn === "true" ? <Dashboard /> : <Login />}
            ></Route>*/}
                  <Route
                    path="/cigna"
                    element={
                      isLoggedIn === "true" ? <MakePayment /> : <Login />
                    }
                  ></Route>
                  <Route
                    path="/christus"
                    element={
                      isLoggedIn === "true" ? <MakePayment /> : <Login />
                    }
                  ></Route>
                  {/*<Route
                  path="/hcsc"
                  element={isLoggedIn === "true" ? <MakePayment /> : <Login />}
                ></Route>*/}
                  <Route
                    path="/bcbsaz"
                    element={
                      isLoggedIn === "true" ? <MakePayment /> : <Login />
                    }
                  ></Route>
                  <Route
                    path="/mountain_health"
                    element={
                      isLoggedIn === "true" ? <MakePayment /> : <Login />
                    }
                  ></Route>
                  <Route
                    path="/sentara"
                    element={
                      isLoggedIn === "true" ? <MakePayment /> : <Login />
                    }
                  ></Route>
                  {/* <Route
              path={`/${urlCarrier}`}
              element={<PrivateRoute Component={<Dashboard />} />}
            ></Route> */}
                  <Route
                    path={`/${urlCarrier}/makepayment`}
                    element={<PrivateRoute Component={<MakePayment />} />}
                  />
                  <Route
                    path={`/${urlCarrier}/confirm`}
                    element={<PrivateRoute Component={<Confirmation />} />}
                  />
                  <Route
                    path={`/${urlCarrier}/notfound`}
                    element={<PrivateRoute Component={<NotFound />} />}
                  />
                  <Route
                    path={`/${urlCarrier}/contact_us`}
                    element={<ContactUs />}
                  ></Route>
                  <Route
                    path={`/${urlCarrier}/glossary`}
                    element={<Glossary />}
                  ></Route>
                  <Route
                      path={`/${urlCarrier}/faq`}
                      element={<Faq />}
                  ></Route>
                  <Route
                    path={`/${urlCarrier}/language_proficiency`}
                    element={<LanguageProficiency />}
                  ></Route>
                  {/*  <Route
                  path={`/${urlCarrier}/language_proficiency`}
                  element={<LanguageProficiency />}
                ></Route>*/}
                  <Route path="*" element={<NotFound />}></Route>
                </Routes>

                {/* <Footer></Footer> */}
              </PaymentNachaProvider>
            </JSEncryptProvider>
          </LanguageProvider>
        </Router>
      </AuthProvider>
    </LogProvider>
  );
}

export default App;
